import {
  ECONOMY,
  QUANTUM,
  DELUXE,
  STANDARD,
  CORE,
  CHOICE,
  EPIC
} from 'core/constants/products'

const titlesPlan = {
  [CHOICE]: 'Cost-effective coverage w/ doctor & Urgent Care copay benefits.',
  [ECONOMY]: 'Basic coverage at our most affordable price.',
  [DELUXE]: 'Prescription drug benefits with no-deductible for generics.',
  [STANDARD]: 'Low deductibles and out-of-pocket limit, plus prescription drug benefits.',
  [CORE]: 'Health plans with doctor copays and low deductibles.',
  [`${QUANTUM}hd`]: 'Access to one of the nation’s largest PPO networks with preventive care coverage and low Rx copays.',
  [`${QUANTUM}copay`]: 'Access to one of the nation’s largest PPO networks with preventive care coverage and low Rx copays.',
  [`${CORE}1000`]: 'Low-deductible accident and illness protection.',
  [`${CORE}2000`]: 'Low-deductible accident and illness protection with Rx.',
  [`${EPIC}-PPO-01`]: 'National network with benefits for preventive care', // ppo without RX
  [`${EPIC}-PPO-04`]: 'National network with prescription drug copays', // ppo with RX
  [`${EPIC}-Non-PPO-01`]: 'All Provider Access with benefits for preventive care', // base without RX
  [`${EPIC}-Non-PPO-04`]: 'All Provider Access with prescription drug copays' // base with RX
}

function getTitlePlan(plan) {
  let id = plan.productId
  if (id === CORE) {
    id += plan.coreBenefits.deductible
  } else if (id === QUANTUM) {
    id += plan.coreBenefits.quantumType
  } else if (id === EPIC) {
    id += `-${plan.coreBenefits.network}-${plan.coreBenefits.rxSchedule}`
  }

  return titlesPlan[id]
}

export default getTitlePlan
